module.exports = __webpack_public_path__ + "static/media/Icon_Studies.85024991.jpg";